import { message } from 'antd';
import FetchData from '@ezviz/FetchData';
import util from '../../utils/utils';
import intl from 'react-intl-universal';

export const FETCH_ACCOUNT_DATA_LIST_LOADING = 'FETCH_ACCOUNT_DATA_LIST_LOADING';
export const FETCH_ACCOUNT_DATA_LIST_SUCCESS = 'FETCH_ACCOUNT_DATA_LIST_SUCCESS';
export const FETCH_ACCOUNT_DATA_LIST_FAILED = 'FETCH_ACCOUNT_DATA_LIST_FAILED';
export const EDIT_ACCOUNT_SUCCESS = 'EDIT_ACCOUNT_SUCCESS';


/**
 * 获取用户信息列表
 * @param {*} param
 */
export function fetchAccountList(param) {
  return (dispatch, getState) => {
    const defaultParam = {
    }
    const req = Object.assign({}, defaultParam, param);
    dispatch({
      type: FETCH_ACCOUNT_DATA_LIST_LOADING,
    });
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/account/list`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: FETCH_ACCOUNT_DATA_LIST_SUCCESS,
          dataList: res.data.content || [],
          dataListTotal: res.data.totalSize,
          pageStart: res.data.pageIndex,
        });
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_ACCOUNT_DATA_LIST_FAILED,
        });
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
      dispatch({
        type: FETCH_ACCOUNT_DATA_LIST_FAILED,
      });
    })
  };
}

/**
 * 修改用户角色
 * @param {*} param
 */
export function editAccount(param, callback) {
  return (dispatch, getState) => {
    const defaultParam = {
    }
    const req = Object.assign({}, defaultParam, param);
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/account/update`, {
      method: 'PUT',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: EDIT_ACCOUNT_SUCCESS,
        });
        callback && callback();
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}

/**
 * 删除用户角色
 * @param {*} param
 */
export function deleteAccount(targetUserId, callback) {
  return (dispatch, getState) => {
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/account/delete?targetUserId=${targetUserId}`, {
      method: 'DELETE',
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        message.success(intl.get('commmon.operate.deleteSuccess'));
        callback && callback();
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}
